import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {baseProfileOptions, centralPowerControlOptions, zoneOptions} from '../../lightProfileSectionConfig';
import {selectImages} from '../../../selectors';


@customElement('page-light-profile')
export class PageLightProfile extends connect(store)(LitElement) {

	static styles = [
		css`

			.lightProfileDetails {
				width: 100%;
				display: block;
			}

			.summaryContent {
				width: 70%;
				container-type: inline-size;
			}

			.lightDiagram {
				margin: 5cqw auto auto auto;
				width: 90%;
			}
			.lightProfileYear {
				width: 100%;
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.profile = state.lightProfile.data.profile;
		this.lightProfile = state.lightProfile.data;
		this.location = state.lightProfile.data.project.location;
		this.lang = state.status.lang;
		this.print = state.status.media === 'print' || status.media === 'print2';
		this.images = selectImages(state);
	}
	firstUpdated() {
		const event = new CustomEvent('captureImages', {bubbles: true, composed: true});
		//this.dispatchEvent(event);
	}

	render() {
		const zpo = zoneOptions.find(zoneOption => zoneOption.id === this.lightProfile.project.zone);
		const zonelabel = zpo ? zpo.label[this.lang] : '';
		const power = centralPowerControlOptions.find(centralPowerControlOption => centralPowerControlOption.id === this.lightProfile.project.centralPowerControl);
		const powerlabel = power ? power.label[this.lang] : '';
		const powerinfo = power ? power.info[this.lang] : '';
		const bpo = baseProfileOptions.find(baseProfileOption => baseProfileOption.id === this.lightProfile.project.base);
		const profileLabel = bpo ? bpo.label[this.lang] : '';
		return html`

			<div slot="content">
				<section class="lightProfileDetails">
					<div class="summaryContent">
						<shared-specsheet-feature>
							<span slot="label">${msg('Circular light profile')}</span>
							<span slot="value">${profileLabel}</span>
						</shared-specsheet-feature>
						<shared-specsheet-feature>
							<span slot="label">${msg('Location')}</span>
							<span slot="value">${this.location.name}</span>
						</shared-specsheet-feature>
						<shared-specsheet-feature>
							<span slot="label">${msg('Zone')}</span>
							<span slot="value">${zonelabel}</span>
						</shared-specsheet-feature>
						<shared-specsheet-feature>
							<span slot="label">${powerlabel}</span>
							<span slot="value">${powerinfo}</span>
						</shared-specsheet-feature>
					</div>

					${when(this.print && this.images && this.images.lightProfileYear, () => html`
							<img src="${this.images.lightProfileYear}" class="lightProfileYear"/>
						`, () => html`
							<light-profile-year class="lightDiagram" size="800"></light-profile-year>
						`)}
				</section>
			</div>
		`;
	}
}
